import { UserResponseDto } from '@app/api';

export const isEmailOrPhoneConfirmed = (user: UserResponseDto) =>
  (Boolean(user.phone) && user.isPhoneConfirmed) ||
  (Boolean(user.email) && user.isEmailConfirmed);
